import IconDownload from "@lhd/components/CloneApp/fields/IconDownload";
import CustomImage from "@lhd/components/CustomImage";
import ModalPreviewOffice from "@lhd/components/Modal/ModalPreviewOffice";
import TextToolTip from "@lhd/components/TextToolTip";
import { TItemAttachment } from "@lhd/features/Apps/AppForm/types";
import ModalVideo from "@lhd/features/Apps/components/ModalVideo";
import {
  checkIsImageByLink,
  checkIsVideoByLink,
  fileCanPreview,
  getNameFileByUrl,
} from "@lhd/features/Apps/utils";
import { Spin } from "antd";
import { Suspense, useState } from "react";

interface IProps {
  attachments?: TItemAttachment[];
  isShowTooltip?: boolean;
}
const HEIGHT_MEDIA = 150;
const WIDTH_MEDIA = "100%";
const Attachments = ({ attachments, isShowTooltip = true }: IProps) => {
  const [openModal, setOpenModal] = useState(false);
  const [urlPreview, setUrlPreview] = useState("");

  const renderContent = (attachment: TItemAttachment) => {
    const url = attachment.url;
    const isAllowDownload = attachment.is_allow_download_attachment;
    const extension = fileCanPreview(url);
    const element =
      checkIsVideoByLink(url) || checkIsImageByLink(url) ? (
        <div
          style={{
            display: "inline-block",
            width: WIDTH_MEDIA,
          }}
        >
          {checkIsImageByLink(url) ? (
            <CustomImage
              width={"100%"}
              height={"100%"}
              style={{
                maxHeight: HEIGHT_MEDIA,
              }}
              src={url}
            />
          ) : (
            <ModalVideo src={url} />
          )}
        </div>
      ) : (
        <p
          onClick={() => {
            if (!extension) return;
            extension && setOpenModal(true);
            setUrlPreview(url);
          }}
          style={{
            width: "calc(100% - 16px)",
            color: extension ? "#1890ff" : "black",
            cursor: extension ? "pointer " : "auto",
          }}
        >
          {isShowTooltip ? (
            <TextToolTip textTooltip={getNameFileByUrl(url)}>
              {getNameFileByUrl(url)}
            </TextToolTip>
          ) : (
            getNameFileByUrl(url)
          )}
        </p>
      );
    return (
      <div className="d-flex ">
        {element} <IconDownload url={url} isDisabled={!isAllowDownload} />
      </div>
    );
  };

  return (
    <div>
      {attachments?.map((attachment, index) => {
        return <div key={index}>{renderContent(attachment)}</div>;
      })}

      {openModal && (
        <Suspense fallback={<Spin />}>
          <ModalPreviewOffice
            modalProps={{
              destroyOnClose: true,
              open: openModal,
              onCancel: () => {
                setOpenModal(false);
              },
            }}
            uri={urlPreview}
          />
        </Suspense>
      )}
    </div>
  );
};

export default Attachments;
